/**
 * Picks v2 or v1 of the Marketing Initiative create/edit form based
 * on the redesign flag.
 */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import MarketingInitiativeForm       from './MarketingInitiativeForm';
import MarketingInitiativeFormPageV2 from './v2/MarketingInitiativeFormPageV2';

export default function MarketingInitiativeFormSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? MarketingInitiativeFormPageV2 : MarketingInitiativeForm;
  return <Component {...props} />;
}
